export function scorePassword(password) {
    let score = 0;
    if (password.length === 0) {
        return { score: score, strength: "bad" };
    }
    const letterCount = {};
    for (const character of password) {
        letterCount[character] = (letterCount[character] || 0) + 1;
        score += 5.0 / letterCount[character];
    }
    const categories = {
        digits: /\d/.test(password),
        lower: /[a-z]/.test(password),
        upper: /[A-Z]/.test(password),
        nonWords: /\W/.test(password),
    };
    const categoryCount = Object
        .values(categories)
        .reduce((total, x) => x ? total + 1 : total, 0);
    score += (categoryCount - 1) * 10;
    score = Math.trunc(score);
    let strength;
    if (score > 80) {
        strength = "strong";
    }
    else if (score > 60) {
        strength = "good";
    }
    else if (score > 40) {
        strength = "weak";
    }
    else {
        strength = "bad";
    }
    return {
        score: score,
        strength: strength,
    };
}
